import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor(
    private httpClient: HttpClient
  ) {
  }


  getPersonalCalendar() {
    const url = environment.base_url + '/api/user/calendar';
    return this.httpClient.post(url, {});
  }
}
